export default "__VITE_ASSET__B$vH3WGv__"